/* eslint-disable @typescript-eslint/no-explicit-any */
import { action, extendObservable, reaction } from 'mobx';
import { Customerships } from './index';
import { apiUrl } from '../config/constants';

type FibreAddress = {
  address: string;
  type: string;
};

// TODO Double check that the initialisations are correct.
class LoginStore {
  configuration: any; // eslint-disable-line
  customerData: Customerships[] = [];
  fibreAvailableList: FibreAddress[] = [];
  logged = false;
  // This is a function but can't type as function.
  restoreSession: any; // eslint-disable-line
  restoringSession = false;
  // This is a function but can't type as function.
  setRestoringSession: any; // eslint-disable-line
  type = '';
  firstName = '';
  lastName = '';
  username = '';

  constructor() {
    extendObservable(this, {
      configuration: <any>{}, // eslint-disable-line
      customerData: [],
      logged: <boolean>false,
      type: <string>'',
      firstName: <string>'',
      lastName: <string>'',
      username: <string>'',
      restoringSession: <boolean>true,
      fibreAvailableList: []
    });
  }

  login = action(async (rt: string, refresh = false) => {
    if (rt === 'remUser' || rt === 'remCompany') {
      rt = 'rem';
    }

    const req = new Request(`${apiUrl}/user/details/${rt}?refresh=${refresh}`, {
      method: 'GET',
      mode: 'cors'
    });

    try {
      const response = await fetch(req);
      // if response is successful but no data has been found for user
      if (response.status === 204) {
        return response;
      } else if (response.ok) {
        const data = await response.json();

        if (data && data.userData.kind === 'consumer') {
          this.customerData = data.companies;
        } else if (data.kind === 'remUser' || data.kind === 'remCompany') {
          this.customerData = data.clients;
        } else if (data.userData.kind === 'companyManager') {
          this.customerData = data.companies;
        } else if (data.userData.kind === 'companyUser') {
          this.customerData = data.companies;
        }
        this.type = data.userData.kind;
        // this.fibreAvailableList = data.fibreAvailableList
        this.firstName = data.userData.firstName;
        this.username = data.userData.email;
        if (data.name) {
          const [head, ...tail] = data.name.split(' ');
          this.firstName = head;
          this.lastName = tail.join(' ');
        } else {
          this.lastName = data.userData.lastName;
        }
        this.logged = true;
      }
      return response;
    } catch (error) {
      sessionStorage.clear();
      console.log(error);
    }
  });

  setConfiguration = action(async (configuration: string) => {
    this.configuration = configuration;
    return Promise.resolve();
  });

  logout = async () => {
    const req = new Request('/api/oauth/logout', {
      method: 'GET',
      mode: 'cors'
    });
    try {
      const res = await fetch(req);
      if (res.ok) {
        sessionStorage.clear();
        this.customerData = [];
        this.type = '';
        this.firstName = '';
        this.lastName = '';
        this.username = '';
        this.logged = false;
      }
    } catch (err) {
      sessionStorage.clear();
    }
  };
  // eslint-disable-line
  getTemplate = (name: string, replacements: any = {}) => {
    let html = this.configuration && this.configuration[name];
    if (!html) {
      return html;
    }
    for (const r in replacements) {
      html = html.replace(r, replacements[r]);
    }
    return html;
  };

  getValue = (name: string) => {
    return this.configuration && this.configuration[name];
  };

  hydrate = action(async () => {
    const firstName = sessionStorage.getItem('firstName');
    const type = sessionStorage.getItem('type');
    const lastName = sessionStorage.getItem('lastName');
    const logged = sessionStorage.getItem('logged');
    const username = sessionStorage.getItem('username');
    if (type) {
      this.type = type;
    }
    if (logged) {
      this.logged = JSON.parse(logged);
    }
    if (username) {
      this.username = username;
    }
    if (firstName && lastName) {
      this.firstName = firstName;
      this.lastName = lastName;
    }
  });
}

const loginStore = new LoginStore();

// set the values to be hydrated from browser storage
reaction(
  () => loginStore.logged,
  logged => {
    if (logged) {
      const store = {
        lastName: loginStore.lastName,
        firstName: loginStore.firstName,
        type: loginStore.type,
        logged: JSON.stringify(loginStore.logged),
        username: loginStore.username
      };

      Object.entries(store).forEach(([key, value]) => {
        if (value !== undefined) {
          sessionStorage.setItem(key, value);
        }
      });
    }
  }
);
export default loginStore as LoginStore;
